import saaf from './reducers/saaf.js';

export default {
    saaf: {
        reducer: saaf,
    },
};
